<div *ngIf="!displayMobileView" 
  [ngClass]="{'content-table-pointer': canEdit}"
>
  <ion-row class="content" (click)="onEditClick(row.id)">
    <ion-col size="2">
      <ion-item lines="none" *ngIf="row.iconName" class="no-background">
        <ion-icon
          slot="start"
          [src]="'../../assets/icons/equipment/' + row.iconName + '.svg'"
        ></ion-icon>
      </ion-item>
    </ion-col>
    <ion-col size="10"> {{ row.name }}</ion-col>
  </ion-row>
</div>

<ion-item *ngIf="displayMobileView" lines="full" (click)="onEditClick(row.id)">
  <ion-icon
    slot="start"
    [src]="'../../assets/icons/equipment/' + row.iconName + '.svg'"
  ></ion-icon>
  <ion-label>
    <h2>{{ row.name }}</h2>
  </ion-label>
</ion-item>
